module.exports = __webpack_public_path__ + "img/load-action.ad1152b5.gif";